import { h, Component } from 'preact';

import { joinClasses } from 'utils/utils';

import { Logo } from 'components/icons/focusFeaturesLogo';
import { getDefaultLandingCtaText, getReleaseMessaging } from 'components/editor/pages/focus/landing/utils';

import s from 'components/editor/pages/focus/landing/upcomingMovies.sss';

export default class UpcomingMovies extends Component {
	constructor(props) {
		super(props);

		this.state = {
			activeItem: 0,
		};

		this.select = this.select.bind(this);
		this.renderLink = this.renderLink.bind(this);
		this.renderPoster = this.renderPoster.bind(this);
	}

	componentDidUpdate(prevProps) {
		if (prevProps.activeElement !== this.props.activeElement) {
			const id = this.props.activeElement?.split('/')?.pop();
			const index = this.props.movies.findIndex(m => m.movie.id === id);
			this.setActiveItem(index);
		}
	}

	select(e) {
		if (this.props.activeElement?.startsWith('/carousels/upcoming/overrides/')) return;
		const el = e.currentTarget;
		const index = [...el.parentElement.children].indexOf(el);
		this.setActiveItem(index);
	}

	setActiveItem(index) {
		if (index == null || index === -1) return;
		this.setState({ activeItem: index });
	}

	renderLink(item, index) {
		const active = index === this.state.activeItem;
		const { movie } = item;
		const releaseMessaging = getReleaseMessaging(movie);
		const ctaText = item.ctaText || getDefaultLandingCtaText(movie);
		return (
			<div
				class={joinClasses(s.link, active && s.active)}
				onFocus={this.select}
				onMouseEnter={this.select}
			>
				{movie.title}
				<span class={s.linkDetails}>
					{releaseMessaging && <span>{releaseMessaging}</span>}
					{ctaText && <span>{ctaText}</span>}
				</span>
			</div>
		);
	}

	renderPoster(item, index) {
		const { movie } = item;
		const active = index === this.state.activeItem;
		let content;
		if (movie.onesheet) {
			content = (
				<img 
					alt={`Poster for ${movie.title}${movie.dates.release ? ` (${movie.dates.release.slice(0, 4)} Movie)` : ''}`}
					src={movie.onesheet?.url || movie.onesheet}
				/>
			);
		} else {
			content = (
				<div class={s.placeholder}>
					<span>{movie.title}</span>
					<Logo class={s.logo} />
				</div>
			);
		}
		return (
			<div
				class={joinClasses(s.poster, active && s.active)}
				tabIndex="-1"
				aria-hidden="true"
				key={movie.slug}
			>
				{content}
			</div>
		);
	}

	render(props) {
		const movies = props.movies;
		if (props.loading === 'loaded' && !movies.length) return null;
		return (
			<div class={s.wrapper}>
				<div class={s.desktop}>
					<div class={s.content}>
						<h2 class={s.title}>New & Upcoming Film Releases</h2>
						<div class={s.links}>{movies.map(this.renderLink)}</div>
					</div>
					<div class={s.posters}>{movies.map(this.renderPoster)}</div>
				</div>
			</div>
		);
	}
}
